import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { SelectCardInformation } from './SelectCardInformation';
import { Icon } from '../../../components/shared';

const icon = {
  book: () => <Icon name="book" size="2xl" color="var(--feel-primary)" />,
  video: () => <Icon name="video" size="2xl" color="var(--feel-primary)" />,
};

const SelectSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 lg:py-24" style={{ backgroundColor: colors.white }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center p-2 mb-6 rounded-full" style={{ backgroundColor: colors.carouselPink }}>
            <Icon name="menu" size="lg" color="var(--feel-primary)" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: colors.mineShaft }}>
            {t('SELECT_SECTION.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">{t('SELECT_SECTION.description')}</p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {SelectCardInformation.map(card => (
            <div
              key={card.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-gray-200"
            >
              <div>
                <div className="text-center">
                  <div
                    className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300"
                    style={{ backgroundColor: colors.carouselPink }}
                  >
                    {icon[card.image]()}
                  </div>
                  <h3 className="text-2xl font-bold mb-4 group-hover:transition-colors duration-200" style={{ color: colors.mineShaft }}>
                    {t(`SELECT_SECTION.${card.image}.title`)}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">{t(`SELECT_SECTION.${card.image}.description`)}</p>
                </div>
                <div className="space-y-2">
                  {t(`SELECT_SECTION.${card.image}.feature1`) &&
                    t(`SELECT_SECTION.${card.image}.feature1`) !== `SELECT_SECTION.${card.image}.feature1` && (
                      <div className="flex items-center space-x-2">
                        <div className="w-2 h-2 rounded-full bg-feel-primary" />
                        <span className="text-sm text-gray-500">{t(`SELECT_SECTION.${card.image}.feature1`)}</span>
                      </div>
                    )}
                  {t(`SELECT_SECTION.${card.image}.feature2`) &&
                    t(`SELECT_SECTION.${card.image}.feature2`) !== `SELECT_SECTION.${card.image}.feature2` && (
                      <div className="flex items-center space-x-2">
                        <div className="w-2 h-2 rounded-full bg-feel-primary" />
                        <span className="text-sm text-gray-500">{t(`SELECT_SECTION.${card.image}.feature2`)}</span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SelectSection;
